import { useState } from 'react';
import { Rules } from '../board/Rules';
import { onlineEnabled } from '../online/config';
import { useStore } from '../store';
import { loadStats } from '../stats';
import { resetTips } from '../tips';

export function Title() {
  const hasSave = useStore((s) => s.hasSave);
  const setScreen = useStore((s) => s.setScreen);
  const resume = useStore((s) => s.resume);
  const [rules, setRules] = useState(false);
  const stats = loadStats();
  return (
    <main className="title">
      <div className="title__inner">
        <div className="eyebrow">A world domination game</div>
        <h1 className="title__logo">
          HOR<span className="title__bite">D</span>E
        </h1>
        <p className="title__lede">
          Conquer the world before the dead do. Every turn you must draw a card, and the horde rises
          whether you are ready or not.
        </p>
        <div className="title__actions">
          <button className="btn btn--primary" onClick={() => setScreen('new')}>
            New game
          </button>
          {hasSave && (
            <button className="btn" onClick={() => resume()}>
              Continue
            </button>
          )}
          {onlineEnabled && (
            <button className="btn" onClick={() => setScreen('online')}>
              Play online
            </button>
          )}
          <button className="btn btn--ghost" onClick={() => setRules(true)}>
            How to play
          </button>
        </div>
        {stats.played > 0 && (
          <div className="record num">
            <span>{stats.played} played</span>
            <span>{stats.wins} won</span>
            <span>{stats.fallen} fallen</span>
            <span>best round {stats.bestRound}</span>
            <button
              className="btn btn--ghost btn--sm"
              onClick={() => {
                resetTips();
                window.alert('First-game tips will show again.');
              }}
            >
              Show tips again
            </button>
          </div>
        )}
        {rules && <Rules onClose={() => setRules(false)} />}
      </div>
      <a className="title__legal" href="/privacy/">
        Privacy
      </a>
    </main>
  );
}
